// extracted by mini-css-extract-plugin
export default {"DownloadPrintable":"TXl_49ruodK0r50ErISS"};